import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { applicationStore } from '@pascal/pascal-core';

import { gameStore } from '../../../store';
import jet from '../../../assets/images/fighters-image/jet.png';
import users from '../../../assets/images/fighters-image/users.png';
import jetEllipse from '../../../assets/images/fighters-image/jet-elipse.png';
import usersLayer from '../../../assets/images/fighters-image/users-layer.png';

export const BetAndCashOutCount = observer(() => {
  const { isDemo } = applicationStore;
  const {
    betCountData: { realBetsCount, realBetsCashOutCount, demoBetsCount, demoBetsCashOutCount },
  } = gameStore;

  const betsCount = useMemo(() => {
    if (isDemo) {
      return realBetsCount + demoBetsCount;
    }
    return realBetsCount;
  }, [isDemo, realBetsCount, demoBetsCount]);

  const cashOutsCount = useMemo(() => {
    if (isDemo) {
      return realBetsCashOutCount + demoBetsCashOutCount;
    }
    return realBetsCashOutCount;
  }, [isDemo, realBetsCashOutCount, demoBetsCashOutCount]);

  return (
    <div className='fighters-game-info-wrp'>
      <div className='fighters-game-img1'>
        <img src={jetEllipse} alt='' />
        <div className='fighters-game-img2'>
          <img src={jet} alt='' />
        </div>
      </div>
      <p className='fighters-game-info1'>{betsCount || 0}</p>
      <div className='fighters-game-img3'>
        <img src={usersLayer} alt='' />
        <div className='fighters-game-img4'>
          <img src={users} alt='' />
        </div>
        <p className='fighters-game-info2'>{cashOutsCount || 0}</p>
      </div>
    </div>
  );
});
